import { ENDPOINT_PERSONAL_ACCESS_TOKENS } from '../config'
import type { PatSummary } from '../types'
import AuthAxios from '@/lib/api/axios/AuthAxios'

const listPersonalAccessTokens = async (): Promise<Array<PatSummary>> => {
  const response = await AuthAxios.get<Array<PatSummary>>(
    ENDPOINT_PERSONAL_ACCESS_TOKENS,
  )
  return response.data
}

export default listPersonalAccessTokens
